
const zafClient = window.zafClient

export default zafClient


export async function getMetadata() {
  const metadata = await zafClient.metadata()
  return metadata
}

export async function getZendeskUrl() {
  const { account } = await zafClient.context()
  return `https://${account.subdomain}.zendesk.com`
}

export async function openModal(endpoint, size, parameter = null, onClose = null ) {
  const url = window.location.origin;
  const modalContext = await zafClient.invoke('instances.create', {
    location: 'modal',
    url: `${url}/#${endpoint}`,
    size
  })
  
  const modalId = modalContext['instances.create'][0].instanceGuid
  const modalClient = zafClient.instance(modalId);

  if (parameter) {
    modalClient.on('ready', function onReady() {
      modalClient.trigger('send_message', parameter)
      modalClient.off('ready', onReady)
    })
  }

  if (onClose) {
    modalClient.on('modal.close', onClose)
  }

  return modalId
}

export async function serializeFields(fieldMap) {
  const { installationId, settings } = await getMetadata()

  const objectField = await zafClient.request({
    url: `/api/v2/apps/installations/${installationId}.json`,
    type: 'PUT',
    data: {
      settings: {
        accessToken: settings.accessToken,

        // { field_vtex1: 222222, field_vtex2: 33333 } => "field_vtex1:222222,field_vtex2:33333"
        linkedFields: Object.entries(fieldMap)
          .filter(([_, id]) => id !== 0)
          .map(([key, value]) => key + ':' + value)
          .join(',')
      }
    }
  })
  return objectField
}

export function receiveMessage() {
  return new Promise(rs => {
    zafClient.trigger('ready')
    zafClient.on('send_message', (parameter) => {
      rs(parameter)
    })
  })
}

export async function deserializeFields() {
  const { installationId } = await getMetadata()
  // Não usamos zafClient.metadata().settings pois este cacheia
  // os resultados e queremos sempre o metadata atualizado
  const { settings } = await zafClient.request({
    type: 'GET',
    url: '/api/v2/apps/installations/' + installationId
  })

  delete settings['name']
  delete settings['title']
  delete settings['accessToken']

  if (!settings.linkedFields) {
    return {}
  }

  // "field_vtex1:222222,field_vtex2:33333" => { field_vtex1: 222222, field_vtex2: 33333 }
  return Object.fromEntries(
    settings.linkedFields
      .split(',')
      .map(string => {
        let [vtexProp, id] = string.split(':')
        return [vtexProp, parseInt(id, 10)]
      })
  )
}

export async function setTicketCustomFieldSidebar(fieldId, value) {
  const fieldName = `custom_field_${fieldId}`
  zafClient.set(`ticket.customField:${fieldName}`, value)
}

export async function getActiveFields() {
  const response = await zafClient.request({
    type: 'GET',
    url: `/api/v2/ticket_fields`
  })
  return response.ticket_fields
}

export async function getGroups() {
  const url = '/api/v2/groups'
  const data = await zafClient.request({
    method: 'GET',
    url
  })
  return data['groups']
}

export async function getBrands() {
  const url = '/api/v2/brands'
  const data = await zafClient.request({
    method: 'GET',
    url
  })
  return data['brands']
}

export async function getForms() {
  const url = '/api/v2/ticket_forms'
  const data = await zafClient.request({
    method: 'GET',
    url
  })
  return data['ticket_forms']
}

export async function getZendeskUser() {
  const url = `/api/v2/users`
  const resp = await zafClient.request({
    method: 'GET',
    url
  })
  return resp['users'];
}

export async function getAllTicketFields() {
  const url = '/api/v2/ticket_fields'
  const resp = await zafClient.request({
    method: 'GET',
    url
  })
  return resp["ticket_fields"]
}

export async function getFormFieldsByFormId(formId) {
  const url = `/api/v2/ticket_forms/${formId}`
  const data = await zafClient.request({
    method: 'GET',
    url
  })
  return data['ticket_form']['ticket_field_ids']
}

export async function getTicketsByFieldValue(fieldId, fieldValue) {
  const url = `/api/v2/search.json?query=custom_field_${fieldId}:${fieldValue}`
  const resp = await zafClient.request({
    method: 'GET',
    url
  })
  return resp['results']
}

export async function createTicket(ticket) {
  const url = `/api/v2/tickets.json`

  return await zafClient.request({
    method: 'post',
    contentType: 'application/json',
    data: JSON.stringify({
      "ticket": ticket
    }),
    url
  })
}

export function popupInfo(string, sticky = false) {
  zafClient.invoke('notify', string, 'notice', { sticky })
}

export function popupError(string, sticky = false) {
  zafClient.invoke('notify', string, 'error', { sticky })
}